module.exports = __webpack_public_path__ + "img/image6.bf3b90df.png";